import { ButtonPromo } from '@sbercloud/uikit-product-button-predefined';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Size } from '@snack-uikit/input-private';
import { Skeleton } from '@snack-uikit/skeleton';
import { useAuth } from 'react-oidc-context';

import { Condition } from '@/components/static';
import { useServerDataCtx } from '@/hooks/ctx';
import { useFormatConsoleUrl } from '@/hooks/useConsoleUrl';
import { useLayoutType } from '@/hooks/useLayoutType';
import { getGlobalArgs } from '@/root/global';
import { isLargeThan } from '@/utils/layout';

import s from './styles.module.scss';
import { UserDetails } from './UserDetails';
type ConsoleButtonProps = {
  fullWidth?: boolean;
  size?: Size;
};

export function ConsoleButton(props: ConsoleButtonProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  const toConsoleButtonText = isAuthenticated ? 'Личный кабинет' : 'Войти';

  const logInUrl = useFormatConsoleUrl(
    getGlobalArgs('NEXT_PUBLIC_CONSOLE_URL', 'cloud.ru'),
    'header',
    toConsoleButtonText,
  );
  const regInUrl = useFormatConsoleUrl(
    getGlobalArgs('NEXT_PUBLIC_CONSOLE_REGISTRATION_URL', 'cloud.ru'),
    'header',
    'Регистрация',
  );

  if (isLargeThan('tablet', layoutType) && isLoading) {
    return <Skeleton loading width={100} height={32} />;
  }

  return (
    <div className={s.console_buttons_wrapper}>
      <ButtonFilled {...props} label={toConsoleButtonText} appearance='primary' href={logInUrl} target='_blank' />
      <Condition when={!isAuthenticated}>
        <ButtonPromo {...props} appearance='secondary' label='Зарегистрироваться' href={regInUrl} target='_blank' />
      </Condition>

      <div className={s.console_button_wrapper}>
        <UserDetails />
      </div>
    </div>
  );
}
